import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Styleclasses from "./UploadDoc.module.css";
import { FileUploader } from "react-drag-drop-files";
import { upload_with_token, save_documents_with_token } from "Services/Requests";
import Upload from "Assets/upload.png";
import Load from "Components/Loader/loader";
import { useForm, SubmitHandler } from "react-hook-form";
import { showSuccessNotification } from "Utils/Notifications";
import { showWarningAlert } from "Utils/Alerts";
import { FaDownload } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

type Inputs = {
    download_id: string;
    file_type: string;
    comments: string;
    file_name: string;
};

const Fileupload = () => {
    return (
        <div className={Styleclasses["File-upload"]}>
            <img src={Upload} alt="upload" />
            <p>Upload File</p>
        </div>
    );
};

const DocTypes = [
    "W2-wage statement",
    "Personal id proof",
    "1099 INT",
    "1099 DIV",
    "1099-G State Tax Refund",
    "1099 MISC ( Self-employed business income )",
    "1099-B Stock Doc",
    "1099 -R",
    "1099-R (401k plan)",
    "5498 -SA ",
    "1098-T (Tuition fees)",
    "1098-E (interest on your student loan)",
    "1120-K1",
    "1065-k1",
    "1042-S",
    "Residents of MA - 1099HC",
    "Child/Dependent Care expenses (SSN/Tax ID required)",
    "Other",
];

function UploadDocumentPage() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [location, setLocation] = useState("");
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
        if (!token) {
            showWarningAlert("Invalid access token. Please use a valid link.");
        }
    }, [token]);
    
    const handleChange = (filesS: File) => {
        if (!token) {
            showWarningAlert("Token is missing. Unable to upload file.");
            return;
        }
        
        const formD = new FormData();
        formD.append("file", filesS);
        formD.append("folder", "documents");
        setLoading(true);
        
        upload_with_token(formD, token)
            .then((res: any) => {
                console.log(res);
                setLoading(false);
                if (res?.data?.status === 1) {
                    setLocation(res?.data?.fileUrl);
                    setValue("download_id", `${res?.data?.fileName}`);
                    showSuccessNotification("File uploaded successfully");
                }
            })
            .catch((err) => {
                setLoading(false);
                showWarningAlert(err?.message || "Error uploading file");
                console.log(err);
            });
    };

    const {
        register,
        handleSubmit,
        setValue,
        resetField,
        reset,
        watch,
        formState: { errors },
    } = useForm<Inputs>();

    const downloadId = watch("download_id");

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        if (!token) {
            showWarningAlert("Token is missing. Unable to save document.");
            return;
        }
        
        console.log(data);
        setLoading(true);
        try {
            const response = await save_documents_with_token([data], token);
            setLoading(false);
            if (response.data.Status === 1) {
                showSuccessNotification("Document saved successfully");
                setLocation("");
                reset();
            } else {
                showWarningAlert(
                    response?.data.Message || "Something went wrong try again"
                );
            }
        } catch (err: any) {
            setLoading(false);
            showWarningAlert(
                "Something went wrong try again, if issue persists contact support team"
            );
            console.log(err);
        }
    };

    return (
        <div className={Styleclasses["Container"]}>
            {loading && <Load />}
            {token ? (
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={Styleclasses["info"]}>
                        <h3>Upload Documents</h3>
                        <div className={Styleclasses["form-control"]}>
                            <label htmlFor="">Document Name</label>
                            <input
                                type="text"
                                placeholder="Enter Document Name"
                                {...register("file_name", { required: "Document name is required" })}
                            />
                            {errors.file_name && (
                                <span style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                                    {errors.file_name.message}
                                </span>
                            )}
                        </div>
                        <div className={Styleclasses["form-control"]}>
                            <label htmlFor="">Document Type</label>
                            <select
                                id=""
                                {...register("file_type", { required: "Document type is required" })}>
                                <option value="">Please Select</option>
                                {DocTypes.map((item, index) => (
                                    <option key={index} value={item}>{item}</option>
                                ))}
                            </select>
                            {errors.file_type && (
                                <span style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                                    {errors.file_type.message}
                                </span>
                            )}
                        </div>
                        <div
                            className={Styleclasses["form-control"]}
                            style={{ gridColumn: "1/-1" }}>
                            <label htmlFor="">Comments</label>
                            <textarea
                                {...register("comments", { required: false })}
                                rows={6}
                                placeholder="Enter Comments"></textarea>
                        </div>
                        <div
                            className={Styleclasses["form-control"]}
                            style={{ gridColumn: "1/-1" }}>
                            <label htmlFor="">Upload File</label>
                            <input
                                type="hidden"
                                {...register("download_id", { required: "File upload is required" })}
                            />
                            <FileUploader
                                handleChange={handleChange}
                                name="file"
                                children={<Fileupload />}
                            />
                            {errors.download_id && (
                                <span style={{ color: "red", fontSize: "12px", marginTop: "4px", display: "block" }}>
                                    {errors.download_id.message}
                                </span>
                            )}
                            {location.length > 0 && (
                                <div className={Styleclasses["download-icon"]}>
                                    <div onClick={() => window.open(location)}>
                                        <FaDownload color="#2db2bc" /> Download
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setLocation("");
                                            resetField("download_id");
                                        }}>
                                        <MdDelete color="red" />
                                    </button>
                                </div>
                            )}
                        </div>
                        <div
                            className={Styleclasses["action-btns"]}
                            style={{ gridColumn: "1/-1" }}>
                            <button
                                style={{ width: "9rem" }}
                                disabled={!downloadId || location.length == 0}>
                                Upload Doc
                            </button>
                        </div>
                    </div>
                </form>
            ) : (
                <div className={Styleclasses["info"]}>
                    <h3>Invalid Access</h3>
                    <p>Please use a valid link with authentication token.</p>
                </div>
            )}
        </div>
    );
}

export default UploadDocumentPage;
